export default __webpack_public_path__ + "static/media/Foundation.c0cbb004.ttf";